import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { loadingWrapper } from '../../../utils/loadingWrapper';
import useTag from '../../../hooks/useTag';
import { setShowEditTagUserModal, setSelectedTag, setShowEditTagDoorModal } from '../../../slice/editTagSlice';
import { hexColorRegex } from '../../../utils/constants';
import { toast } from 'react-toastify';
import { setBody, setOnCancel, setOnConfirm, setShow, setTitle, resetConfirmModal } from '../../../slice/confirmModalSlice';
import { privileges } from '../../../config/role';

const EditUserTag = ({ onSuccess }) => {
  const dispatch = useDispatch();
  const show = useSelector((s) => s.editTag.showEditTagDoorModal);
  const selectedTag = useSelector((s) => s.editTag.selectedTag);
  const userRole = useSelector((state)=> state.user.role);
  const authorized = privileges.editingDoorTags.includes(userRole);
  const { tagLoading, editDoorTag, deleteDoorTag } = useTag();

  const [isEditEnabled, setEditEnabled] = useState(false);
  const [tagData, setTagData] = useState({
    id: undefined,
    name: '',
    type: '',
    color: '',
    extId: '',
  });

  useEffect(() => {
    if (selectedTag) {
      setTagData({
        id: selectedTag.id,
        name: selectedTag.name || '',
        type: selectedTag.type || '',
        color: selectedTag.color || '',
        extId: selectedTag.extId ?? '',
      });
      setEditEnabled(false);
    }
  }, [selectedTag]);

  const inputValidator = {
    name: tagData.name.trim().length > 0,
    type: tagData.type.trim().length > 0,
    color: tagData.color === '' || hexColorRegex.test(tagData.color.trim()),
  };

  const isDisabled = !(inputValidator.name && inputValidator.type && inputValidator.color);

  const inputHandler = (e) => {
    const { name, value } = e.target;
    setTagData((prev) => ({ ...prev, [name]: value }));
  };

  const closeEdit = () => {
    if (!tagLoading) {
      dispatch(setShowEditTagDoorModal());
      dispatch(setSelectedTag(null));
      setTagData({ id: undefined, name: '', type: '', color: '', extId: '' });
      setEditEnabled(false);
    }
  };

  const editHandler = () => setEditEnabled((v) => !v);

  const cancelEdit = () => {
    if (!selectedTag) return;
    setTagData({
      id: selectedTag.id,
      name: selectedTag.name || '',
      type: selectedTag.type || '',
      color: selectedTag.color || '',
      extId: selectedTag.extId ?? '',
    });
    setEditEnabled(false);
  };

  const openConfirmEdit = () => {
    dispatch(setTitle('Conferma Modifica'));
    dispatch(setBody(`Confermi la modifica dell' Ufficio ${tagData?.name || ''}?`));

    
    dispatch(setOnConfirm(() => {
      dispatch(resetConfirmModal());
      sendUpdate();
    }));

    
    dispatch(setOnCancel(() => {
      dispatch(resetConfirmModal());
    }));

    
    dispatch(setShow());
  };

  const sendUpdate = () => {
    if(!authorized) return;
    if (!tagData.id) return;
    const payload = {
      name: tagData.name.trim(),
      type: tagData.type.trim(),
      color: tagData.color.trim(),
      extId: tagData.extId?.toString() ?? '',
    };
    editDoorTag(
      tagData.id,
      payload,
      () => {
        toast.success('Ufficio aggiornato con successo');
        onSuccess?.();
        closeEdit();
      },
      () => {
        toast.error('Errore nell’aggiornamento dell\' Ufficio');
      }
    );
  };

const confirmDelete = () => {
    dispatch(setTitle('Conferma Cancellazione'));
    dispatch(setBody(`Confermi l'eliminazione dell'Ufficio ${tagData?.name || ''}? L'azione è irreversibile.`));

    
    dispatch(setOnConfirm(() => {
        dispatch(resetConfirmModal());
        sendDelete();
    }));

    
    dispatch(setOnCancel(() => {
        dispatch(resetConfirmModal());
    }));

    
    dispatch(setShow());
};

const sendDelete = () => {
  if(!authorized) return;
  if (!tagData.id) return;
  deleteDoorTag(
    tagData.id,
    () => {
      toast.success('Ufficio eliminato con successo');
      onSuccess?.();
      closeEdit(); 
    },
    () => toast.error('Errore nella cancellazione dell’Ufficio')
  );
};


  return (
    <Modal
      show={show}
      size="md"
      backdrop={isEditEnabled ? 'static' : true}
      onHide={tagLoading ? null : closeEdit}
    >
      <Modal.Header closeButton>
        <Modal.Title className='text-primary-custom'>{isEditEnabled ? 'Modifica Gruppo' : 'Info Gruppo'}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="d-flex flex-column gap-3">
          <fieldset className="detail-fieldset flex-column gap-2 align-items-center w-100">
            <legend className="detail-legend text-primary-custom">Dati Gruppo</legend>
            <div className="d-flex flex-column gap-2 w-100">
              <div className="d-flex flex-column w-100">
                <p className="m-0">Nome</p>
                <input
                  className={`form-control ${inputValidator.name ? '' : 'is-invalid'}`}
                  type="text"
                  name="name"
                  value={tagData.name}
                  onChange={inputHandler}
                  disabled={!isEditEnabled}
                />
              </div>
              <div className="d-flex flex-column w-100">
                <p className="m-0">Tipo</p>
                <input
                  className={`form-control ${inputValidator.type ? '' : 'is-invalid'}`}
                  type="text"
                  name="type"
                  value={tagData.type}
                  onChange={inputHandler}
                  disabled={!isEditEnabled}
                />
              </div>
            </div>
          </fieldset>

          <fieldset className="detail-fieldset flex-column gap-2 align-items-center w-100">
            <legend className="detail-legend text-primary-custom">Altro</legend>
            <div className="d-flex w-100 gap-2">
              <div className="d-flex flex-column w-100 justify-content-center">
                <p className="m-0">Colore</p>
                <input
                  className={`form-control ${inputValidator.color ? '' : 'is-invalid'}`}
                  maxLength={7}
                  type="text"
                  name="color"
                  value={tagData.color}
                  placeholder="#FFFFFF"
                  onChange={inputHandler}
                  disabled={!isEditEnabled}
                />
              </div>
              <div className="d-flex flex-column justify-content-end mb-1">
                <div
                  style={{
                    width: '25px',
                    height: '25px',
                    borderRadius: '50%',
                    backgroundColor: `${hexColorRegex.test(tagData.color.trim()) ? tagData.color.trim() : ''}`,
                  }}
                />
              </div>
            </div>
          </fieldset>

          {authorized &&<fieldset className="detail-fieldset gap-2 justify-content-center">
            <legend className="detail-legend text-primary-custom">Azioni</legend>
            {!isEditEnabled ? (
              <>
                <Button variant="danger" onClick={editHandler}>
                  Modifica
                </Button>
                <Button variant="secondary" onClick={closeEdit}>
                  Chiudi
                </Button>
                <Button variant="danger" onClick={confirmDelete}>
                        {loadingWrapper(tagLoading, <>Elimina</>)}
                </Button>
              </>
            ) : (
              <>
                <Button variant="secondary" onClick={cancelEdit} disabled={tagLoading}>
                  Annulla
                </Button>
                <Button className="btn-green" disabled={isDisabled || tagLoading} onClick={openConfirmEdit}>
                  {loadingWrapper(tagLoading, <>Conferma</>)}
                </Button>
              </>
            )}
          </fieldset>}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default EditUserTag;
